import { render } from "./simpeg-dashboard-filter.vue?vue&type=template&id=a6228b58&scoped=true"
import script from "./simpeg-dashboard-filter.vue?vue&type=script&lang=js"
export * from "./simpeg-dashboard-filter.vue?vue&type=script&lang=js"

import "./simpeg-dashboard-filter.vue?vue&type=style&index=0&id=a6228b58&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6228b58"]])

export default __exports__